import { useEffect, useRef } from "react";
import { sendDataToIframe } from "../utils/editIframe";

const Iframe = ({ path, data, contentKey = "pageContent" }) => {
  const origin = process.env.REACT_APP_ORIGIN;
  const iframeRef = useRef(null);
  const isLoadedRef = useRef(false);

  useEffect(() => {
    if (!iframeRef.current) return;

    const handleIframeLoad = () => {
      isLoadedRef.current = true;
      if (data) {
        sendDataToIframe(data, contentKey, origin);
      }
    };

    const iframe = iframeRef.current;
    iframe.addEventListener("load", handleIframeLoad);

    // すでにロード済みの場合はデータを送信
    if (isLoadedRef.current && data) {
      sendDataToIframe(data, contentKey, origin);
    }

    return () => {
      iframe.removeEventListener("load", handleIframeLoad);
    };
  }, [data, contentKey, origin]);

  // データが変更されたときに送信
  useEffect(() => {
    if (isLoadedRef.current && data) {
      sendDataToIframe(data, contentKey, origin);
    }
  }, [data, contentKey, origin]);

  // If path is a full URL, use it directly, otherwise combine with origin
  const src = path.startsWith("http") ? path : `${origin}${path}`;
  return <iframe ref={iframeRef} src={src}></iframe>;
};

export default Iframe;
